// extracted by mini-css-extract-plugin
export default {"addProductForm":"AddProduct_addProductForm__l7vxG"};